import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdressatResource, AufgabeResource, AufgabeRootState } from '@schir-int-client/aufgabe-shared';
import {
	downloadKorrespondenzAction,
	downloadKorrespondenzenArchivAction,
	downloadKorrespondenzenMergeAction,
} from './korrespondenz.actions';

@Injectable({ providedIn: 'root' })
export class KorrespondenzFacade {
	constructor(private store: Store<AufgabeRootState>) {}

	getKorrespondenz(adressat: AdressatResource) {
		this.store.dispatch(downloadKorrespondenzAction({ adressat }));
	}

	getKorrespondenzenArchiv(aufgabe: AufgabeResource) {
		this.store.dispatch(downloadKorrespondenzenArchivAction({ aufgabe }));
	}

	getKorrespondenzenMerge(aufgabe: AufgabeResource) {
		this.store.dispatch(downloadKorrespondenzenMergeAction({ aufgabe }));
	}
}
